/** An empty calendar slot staff clicked: the date and the start time, in seconds from midnight. */
export type CalendarSlot = {
  date: string;
  startSeconds: number;
};

const HOUR_SECONDS = 60 * 60;
const LAST_MINUTE_OF_DAY_SECONDS = 24 * HOUR_SECONDS - 60;

/** Default end for things created from a slot (note, availability, shift): an hour later, kept within the day. */
export const slotEndSeconds = (slot: CalendarSlot) =>
  Math.min(slot.startSeconds + HOUR_SECONDS, LAST_MINUTE_OF_DAY_SECONDS);
